var listLayout = "https://shopfront-cdn.tekoapis.com/static/10a387fb698bb09d.svg";

export { listLayout as default };
